export default __webpack_public_path__ + "static/media/chrishawkes.9299464a.webp";